export * from "./types.js";
export * from "./copy.js";
export {
  payoffSchedule,
  minimumTrap,
  minimumRepayment,
  assertNoCreditHandoff,
} from "./calculate.js";
export { rates_2026_06_05 } from "./rates-2026-06-05.js";

import type { CardPayoffRateSet } from "./types.js";
import { rates_2026_06_05 } from "./rates-2026-06-05.js";

/**
 * Registry of benchmark/defaults sets, keyed by their effective date. These are
 * DEFAULTS and CONTEXT only (RBA F5 average APRs + the typical minimum rule) —
 * they do NOT gate the maths (the user's own rate + repayment are the inputs).
 * Date-keyed (not FY-keyed): there is no annual tax table here. Historical
 * periods stay registered so a re-run resolves against the benchmarks in force
 * then; a refresh is a new rates-YYYY-MM-DD.ts, never a mutation of a shipped one.
 */
export const CREDIT_CARD_PAYOFF_RATESETS: Record<string, CardPayoffRateSet> = {
  "2026-06-05": rates_2026_06_05,
};

/** The benchmark sets, newest first — for date resolution. */
const RATESETS_DESC: readonly CardPayoffRateSet[] = Object.values(
  CREDIT_CARD_PAYOFF_RATESETS,
).sort((a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1));

/**
 * Resolve the benchmark set in force on an ISO date (YYYY-MM-DD). Pure string
 * comparison — ISO dates sort lexically. Picks the most recent period whose
 * `[effectiveFrom, effectiveTo]` window contains the date. Throws if the date
 * predates the earliest period.
 */
export function creditCardPayoffRatesForDate(isoDate: string): CardPayoffRateSet {
  for (const set of RATESETS_DESC) {
    const afterStart = isoDate >= set.effectiveFrom;
    const beforeEnd = set.effectiveTo === null || isoDate <= set.effectiveTo;
    if (afterStart && beforeEnd) return set;
  }
  throw new Error(`no card-payoff benchmark set registered for date ${isoDate}`);
}

/** The current (most recent) benchmark set — default for live "now" estimates. */
export const CREDIT_CARD_PAYOFF_CURRENT_RATESET: CardPayoffRateSet =
  rates_2026_06_05;
